import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { SERVICES } from "../lib/content";
import SectionTitle from "../components/site/SectionTitle";
import GeometricDivider from "../components/site/GeometricDivider";

export default function Services() {
  useEffect(() => { document.title = "Services & Solutions — Hazrat Sufi Sarkar"; }, []);
  return (
    <div data-testid="services-page">
      <section className="pattern-emerald text-ivory pt-32 pb-24" data-testid="services-hero">
        <div className="container-page text-center">
          <span className="text-[11px] uppercase tracking-[0.32em] text-gold">Services</span>
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-4 leading-tight">Solutions Rooted in Faith</h1>
          <p className="calligraphy text-gold text-xl mt-5">From the threshold of the dargah to your doorstep</p>
        </div>
      </section>

      <section className="section-pad" data-testid="services-grid">
        <div className="container-page">
          <SectionTitle eyebrow="What we offer" title="A spectrum of spiritual and humanitarian care" subtitle="Each service is an offering of presence — guidance, healing, and dignity for every seeker." />
          <GeometricDivider />
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {SERVICES.map((s, i) => {
              const Icon = Icons[s.icon] || Icons.Sparkles;
              return (
                <div key={s.key} data-testid={`service-${s.key}`} className="card-soft p-8 reveal flex flex-col" style={{ transitionDelay: `${i * 60}ms` }}>
                  <span className="grid place-items-center h-12 w-12 rounded-full border border-gold/50 text-gold mb-5">
                    <Icon size={20} />
                  </span>
                  <h3 className="font-serif text-xl text-emerald">{s.title}</h3>
                  <p className="text-charcoal-muted mt-3 text-sm leading-relaxed flex-1">{s.desc}</p>
                  <Link to="/book" data-testid={`book-${s.key}`} state={{ service: s.title }} className="inline-flex items-center text-gold hover:text-emerald mt-6 transition-colors">
                    Book this service
                    <Icons.ArrowRight className="ml-2" size={16} />
                  </Link>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="pattern-bg section-pad" data-testid="services-cta">
        <div className="container-page max-w-3xl text-center reveal">
          <h2 className="font-serif text-3xl md:text-4xl text-emerald">How We Help You Solve Life's Problems</h2>
          <p className="text-charcoal-muted mt-5 text-lg">Share your story — the trust will gently guide you to the most fitting service.</p>
          <div className="flex flex-wrap items-center justify-center gap-4 mt-8">
            <Link to="/book" className="btn-gold" data-testid="services-book-cta">Book a Session</Link>
            <Link to="/donate" className="btn-outline-gold" data-testid="services-support-cta">Support Our Work</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
